import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bar"]
  static values = {
    value: { type: Number, default: 0 }
  }

  connect() {
    // Initialize bar width if not already set
    if (this.hasBarTarget) {
      this.updateBar()
    }
  }

  valueValueChanged() {
    this.updateBar()
  }

  updateBar() {
    if (!this.hasBarTarget) return

    const clampedValue = Math.max(0, Math.min(100, this.valueValue))
    this.barTarget.style.width = `${clampedValue}%`

    // Update percentage text if present
    // For style2 (tooltip): find the outer span and update its text node
    const tooltipSpan = this.barTarget.querySelector("span.absolute.-right-4")
    if (tooltipSpan) {
      // Find the text node (last child after the arrow span)
      for (let i = tooltipSpan.childNodes.length - 1; i >= 0; i--) {
        if (tooltipSpan.childNodes[i].nodeType === Node.TEXT_NODE) {
          tooltipSpan.childNodes[i].textContent = `${Math.round(clampedValue)}%`
          break
        }
      }
    }
    
    // For style3 (inline label): find the p tag
    const inlineLabel = this.barTarget.querySelector("p")
    if (inlineLabel) {
      inlineLabel.textContent = `${Math.round(clampedValue)}%`
    }

    // Dispatch custom event for external listeners
    this.dispatch("updated", { detail: { value: clampedValue } })
  }

  // Public method to update progress value
  setValue(newValue) {
    this.valueValue = newValue
  }

  // Public method to increment progress
  increment(amount = 1) {
    this.valueValue = Math.min(100, this.valueValue + amount)
  }

  // Public method to decrement progress
  decrement(amount = 1) {
    this.valueValue = Math.max(0, this.valueValue - amount)
  }

  // Public method to animate progress to target value
  animateTo(targetValue, duration = 1000) {
    const startValue = this.valueValue
    const endValue = Math.max(0, Math.min(100, targetValue))
    const startTime = Date.now()

    const animate = () => {
      const elapsed = Date.now() - startTime
      const progress = Math.min(elapsed / duration, 1)
      
      // Easing function (ease-out)
      const eased = 1 - Math.pow(1 - progress, 3)
      
      this.valueValue = startValue + (endValue - startValue) * eased

      if (progress < 1) {
        requestAnimationFrame(animate)
      }
    }

    requestAnimationFrame(animate)
  }

  // Action method for animate random button
  animateRandom(event) {
    event.preventDefault()
    const randomValue = Math.random() * 100
    this.animateTo(randomValue, 1000)
  }

  // Action method for reset button
  reset(event) {
    event.preventDefault()
    this.setValue(0)
  }
}
